import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import PageSectionHeader from '../../../components/PageSectionHeader';
import FlexBox from '../../../../../components/FlexBox';
import OptionsContainer from '../../../components/OptionsContainer';
import messages from '../../messages';
import { required, checkDateOnly, checkFlightDateOnly, checkFlightNumberOnly } from '../../../../../utils/validation/validator';
import { Validate, ErrorMessage, ValidateGroup } from '../../../../../components/Validation';
import DatePicker from '../../../components/DatePicker';
import { AdditionalList } from '../Additional';
import { TravelSupplierList } from '../AddTravelSupplier';
import Select from 'react-select';
import Textbox from '../../../components/Textbox';
import TextArea from '../../../components/TextArea';
import AsyncButtonSendMail from '../../../../../components/AsyncButtonSendMail';
import HelpText from '../../../../../components/HelpText';
import Label from 'components/Label';
import FlightDatePicker from '../../../components/FlightDatePicker/index';
import AsyncButton from '../../../../../components/AsyncButton/index';
import { stepChangesToYourJourneyTrawickLookup } from '../../../../FastCover/dataMapper/claimCodeMapper';
import Section from '../../../components/Section';
import ControlContainer from '../../../components/ControlContainer';

export class TripInterruptionVersion14AndAbove extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            validationCounter: 0,
            errors: [],
        };
        this.validatorGroup = new ValidateGroup();
        this.emailMeDocumentButton = _.uniqueId();
        this.clickedItemId = '';
        this.formResets = {
            'form.reasonsForTripInterruption': [
                'nameOfEmployerTI',
                'whenWereYouNotifiedTI',
                'dateOfTerminationOrLayoffTI',
                'howLongWereYouEmployedTI',
                'wasThisWorkTransferTI',
                'nameOfServiceCallingToActiveDutyTI',
                'dateYouBecameTI',
                'nameOfCourtOrAuthorityTI',
                'dateToAppearInCourtTI',
                'nameOfAuthorityHandlingTheIncidentTI',
                'dateOfIncidentTI',
                'chooseAnInsuredTI',
                'fullNameTI',
                'relationshipToTravelerTI',
                'pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelledTI',
                'nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosureTI',
                'dateOfTransportClosureIncidentTI',
                'dateOfTrafficAccidentTI',
                'nameOfTravelSupplierTI',
                'whenDidOperationsResumeTI',
                'whatCausedTheServiceCessationTI',
                'whenWasThePrimaryResidenceOrDestinationDeemedUninhabitableTI',
                'whereWasUninhabitableTI',
                'provideDetailsOfTheIncidentTI',
                'dateSicknessOrInjuryBeganTI',
            ],
            'form.whoSickOrInjuredCusingTheCancellation': [
                'chooseAnInsuredTI',
                'fullNameTI',
                'relationshipToTravelerTI',
                'pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelledTI',
            ],
            'form.whoHadDiedCausingTheCancellation': [
                'chooseAnInsuredTI',
                'fullNameTI',
                'relationshipToTravelerTI',
                'pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelledTI',
            ],
        };
    }


    handlereasonsForTripInterruption = (path) => (event) => {
        const { reasonsForTripInterruption } = this.props.form;
        const reasons = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
            ? reasonsForTripInterruption.toJS()
            : reasonsForTripInterruption || [];
        const listChecked = [...reasons];
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        if (value) {
            listChecked.push(name);
        } else {
            listChecked.splice(listChecked.indexOf(name), 1);
            const resetFields = this.formResets[path];
            if (resetFields && resetFields.length > 0) {
                this.props.resetFormFields(resetFields);
            }
        }
        this.props.onFormDataChange(path, listChecked);
    };

    handleChange = (path) => (event) => {
        const target = event.target;
        const { onFormDataChange, resetFormFields } = this.props;
        const value = path === 'form.chooseAnInsured' ? event : target.type === 'checkbox' ? target.checked : target.value;
        if (this.formResets[path]) {
            const resetFields = this.formResets[path];
            if (resetFields && resetFields.length > 0) {
                resetFormFields(resetFields);
            }
        }

        onFormDataChange(path, value);
    };

    handleDayChange = (path) => (value) => {
        const { onFormDataChange } = this.props;
        onFormDataChange(path, value);
    };

    handleEmailMeButtonClick = (event) => {
        const target = event.currentTarget || event.srcElement;
        this.clickedItemId = target.id;
        // this.props.sendPhysicianEmail();
    };

    showSpinnerForElement(elementId) {
        return this.clickedItemId === elementId;
    }

    summaryFormValue() {
        return _.mapValues(this.props.form, (prop) => prop || 'N/A');
    }

    renderTravelCancellationAdditionalItems() {
        const { lossInformationItemsTravelCancellation = [] } = this.props.form;
        const newLossInformationItems = this.props.appendIds(lossInformationItemsTravelCancellation);
        const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
        const isReadOnly = submitted || isSummary;

        return (
            <div>
                <AdditionalList
                    data={newLossInformationItems}
                    onChange={this.props.onTravelCancellationItemsChange}
                    isDelayed={false}
                    disabled={isReadOnly}
                    validatorGroup={this.props.validatorGroup}
                    validationCounter={this.props.validationCounter}
                    insuredsList={insuredsList}
                    isClaimForFieldEnabled={isClaimForFieldEnabled}
                />
            </div>
        );
    }

    renderTripInterruptionInformationItems() {
        const { lossInformationItems } = this.props.form;
        const newDelayInformationItems = this.props.appendIds(lossInformationItems);
        const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
        const isReadOnly = submitted || isSummary;

        return (
            <div>
                <AdditionalList
                    data={newDelayInformationItems}
                    onChange={this.props.onTripInterruptionChange}
                    isDelayed={false}
                    disabled={isReadOnly}
                    validatorGroup={this.props.validatorGroup}
                    validationCounter={this.props.validationCounter}
                    insuredsList={insuredsList}
                    isClaimForFieldEnabled={isClaimForFieldEnabled}
                />
            </div>
        );
    }

    renderSickOrInjured() {
        const {
            whoSickOrInjuredCusingTheCancellationTI,
            chooseAnInsuredTI,
            fullNameTI,
            relationshipToTravelerTI,
            dateSicknessOrInjuryBeganTI,
            pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelledTI,
            enableTimeTravelCancellation,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;

        const { isReadOnly, insuredsList } = this.props;
        const buttonEmailMeDisable = !!enableTimeTravelCancellation && new Date().getTime() < enableTimeTravelCancellation;

        return (
            <div className="ml-3">
                <div className="ml-2 col-sm-12 form-group">
                    <Label>
                        <FormattedMessage {...messages.whoSickOrInjuredCusingTheCancellation} />
                    </Label>
                    <div style={{ display: 'grid', margin: '8px 8px 8px 15px' }}>
                        <label>
                            <input
                                type="radio"
                                name="whoSickOrInjuredCusingTheCancellationTI"
                                value="oneOfTravelers"
                                checked={whoSickOrInjuredCusingTheCancellationTI === 'oneOfTravelers'}
                                onChange={this.handleChange('form.whoSickOrInjuredCusingTheCancellationTI')}
                                disabled={isReadOnly}
                            />
                            <FormattedMessage {...messages.oneOfTravelers} />
                        </label>
                        {whoSickOrInjuredCusingTheCancellationTI === 'oneOfTravelers' && (
                            <div className={'row ml-2'} style={{ alignItems: 'center' }}>
                                <div className={'col-sm-3 form-group'}>
                                    <FormattedMessage {...messages.chooseAnInsured} />
                                </div>
                                <div className={'col-sm-6 form-group'}>
                                    <Select
                                        name="chooseAnInsured"
                                        isMulti={false}
                                        isDisabled={isReadOnly}
                                        options={insuredsList}
                                        placeholder="Select Insured(s)"
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        onChange={this.handleChange('form.chooseAnInsuredTI')}
                                        value={chooseAnInsuredTI}
                                        getOptionLabel={(option) => `${option.firstname} ${option.lastname}`}
                                        getOptionValue={(option) => option.id}
                                    />
                                </div>
                            </div>
                        )}
                        <label>
                            <input
                                type="radio"
                                name="whoSickOrInjuredCusingTheCancellationTI"
                                value="familyMemberOfTraveler"
                                checked={whoSickOrInjuredCusingTheCancellationTI === 'familyMemberOfTraveler'}
                                onChange={this.handleChange('form.whoSickOrInjuredCusingTheCancellationTI')}
                                disabled={isReadOnly}
                            />
                            <FormattedMessage {...messages.familyMemberOfTraveler} />
                        </label>
                        {whoSickOrInjuredCusingTheCancellationTI === 'familyMemberOfTraveler' && (
                            <div className="row ml-2" style={{ alignItems: 'center' }}>
                                <div className="col-sm-2 form-group">
                                    <FormattedMessage {...messages.fullName} />
                                </div>
                                <div className="col-sm-6 form-group">
                                    <Textbox
                                        value={fullNameTI}
                                        onChange={this.handleChange('form.fullNameTI')}
                                        disabled={isReadOnly}
                                    />
                                </div>
                            </div>
                        )}
                        <label>
                            <input
                                type="radio"
                                name="whoSickOrInjuredCusingTheCancellationTI"
                                value="hostAtDestination"
                                checked={whoSickOrInjuredCusingTheCancellationTI === 'hostAtDestination'}
                                onChange={this.handleChange('form.whoSickOrInjuredCusingTheCancellationTI')}
                                disabled={isReadOnly}
                            />
                            <FormattedMessage {...messages.hostAtDestination} />
                        </label>
                        {whoSickOrInjuredCusingTheCancellationTI === 'hostAtDestination' && (
                            <div className="row ml-2" style={{ alignItems: 'center' }}>
                                <div className="col-sm-2 form-group">
                                    <FormattedMessage {...messages.fullName} />
                                </div>
                                <div className="col-sm-6 form-group">
                                    <Textbox
                                        value={fullNameTI}
                                        onChange={this.handleChange('form.fullNameTI')}
                                        disabled={isReadOnly}
                                    />
                                </div>
                            </div>
                        )}
                        <label>
                            <input
                                type="radio"
                                name="whoSickOrInjuredCusingTheCancellationTI"
                                value="someoneElse"
                                checked={whoSickOrInjuredCusingTheCancellationTI === 'someoneElse'}
                                onChange={this.handleChange('form.whoSickOrInjuredCusingTheCancellationTI')}
                                disabled={isReadOnly}
                            />
                            <FormattedMessage {...messages.someoneElse} />
                        </label>
                        {whoSickOrInjuredCusingTheCancellationTI === 'someoneElse' && (
                            <div className="ml-4">
                                <div className="row">
                                    <div className="col-sm-6 form-group">
                                        <Label>
                                            <FormattedMessage {...messages.fullName} />
                                        </Label>
                                        <Textbox
                                            value={fullNameTI}
                                            onChange={this.handleChange('form.fullNameTI')}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-sm-6 form-group">
                                        <Label>
                                            <FormattedMessage {...messages.relationshipToTraveler} />
                                        </Label>
                                        <Textbox
                                            value={relationshipToTravelerTI}
                                            onChange={this.handleChange('form.relationshipToTravelerTI')}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <Label>
                                            <FormattedMessage {...messages.pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled} />
                                        </Label>
                                        <TextArea
                                            value={pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelledTI}
                                            onChange={this.handleChange('form.pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelledTI')}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="row" style={{ alignItems: 'center', marginLeft: '22px' }}>
                        <div className="col-sm-3 form-group">
                            <FormattedMessage {...messages.dateSicknessOrInjuryBegan} />
                        </div>
                        <div className="col-sm-6 form-group">
                            <DatePicker
                                value={dateSicknessOrInjuryBeganTI}
                                onChange={this.handleDayChange('form.dateSicknessOrInjuryBeganTI')}
                                disabled={isReadOnly}
                            />
                        </div>
                    </div>
                    <div className="row" style={{ alignItems: 'center', marginLeft: '22px' }}>
                        <div className="col-sm-7 form-group">
                            <FormattedMessage {...messages.statementOfAttendingPhysicianTemplate} />
                        </div>
                        <div className="col-sm-5 form-group">
                            <AsyncButtonSendMail
                                id={this.emailMeDocumentButton}
                                disabled={buttonEmailMeDisable}
                                loading={this.showSpinnerForElement(this.emailMeDocumentButton)}
                                onClick={this.handleEmailMeButtonClick}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderDeath() {
        const {
            whoHadDiedCausingTheCancellationTI,
            dateOfDeathTI,
            chooseAnInsuredTI,
            fullNameTI,
            relationshipToTravelerTI,
            pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelledTI,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly, insuredsList } = this.props;

        return (
            <div className="ml-3">
                <div className="ml-2 col-sm-12 form-group">
                    <Label>
                        <FormattedMessage {...messages.whoHadDiedCausingTheCancellation} />
                    </Label>
                    <div style={{ display: 'grid', margin: '8px 8px 8px 15px' }}>
                        <label>
                            <input
                                type="radio"
                                name="whoHadDiedCausingTheCancellationTI"
                                value="oneOfTravelers"
                                checked={whoHadDiedCausingTheCancellationTI === 'oneOfTravelers'}
                                onChange={this.handleChange('form.whoHadDiedCausingTheCancellationTI')}
                                disabled={isReadOnly}
                            />
                            <FormattedMessage {...messages.oneOfTravelers} />
                        </label>
                        {whoHadDiedCausingTheCancellationTI === 'oneOfTravelers' && (
                            <div className="row ml-2" style={{ alignItems: 'center' }}>
                                <div className="col-sm-3 form-group">
                                    <FormattedMessage {...messages.chooseAnInsured} />
                                </div>
                                <div className="col-sm-6 form-group">
                                    <Select
                                        value={chooseAnInsuredTI}
                                        onChange={this.handleChange('form.chooseAnInsuredTI')}
                                        options={insuredsList}
                                        getOptionLabel={(option) => option.name}
                                        getOptionValue={(option) => option.id}
                                        isDisabled={isReadOnly}
                                    />
                                </div>
                            </div>
                        )}

                        <label>
                            <input
                                type="radio"
                                name="whoHadDiedCausingTheCancellationTI"
                                value="familyMemberOfTraveler"
                                checked={whoHadDiedCausingTheCancellationTI === 'familyMemberOfTraveler'}
                                onChange={this.handleChange('form.whoHadDiedCausingTheCancellationTI')}
                                disabled={isReadOnly}
                            />
                            <FormattedMessage {...messages.familyMemberOfTraveler} />
                        </label>
                        {whoHadDiedCausingTheCancellationTI === 'familyMemberOfTraveler' && (
                            <div className="row ml-2" style={{ alignItems: 'center' }}>
                                <div className="col-sm-2 form-group">
                                    <FormattedMessage {...messages.fullName} />
                                </div>
                                <div className="col-sm-6 form-group">
                                    <Textbox
                                        value={fullNameTI}
                                        onChange={this.handleChange('form.fullNameTI')}
                                        disabled={isReadOnly}
                                    />
                                </div>
                            </div>
                        )}

                        <label>
                            <input
                                type="radio"
                                name="whoHadDiedCausingTheCancellationTI"
                                value="hostAtDestination"
                                checked={whoHadDiedCausingTheCancellationTI === 'hostAtDestination'}
                                onChange={this.handleChange('form.whoHadDiedCausingTheCancellationTI')}
                                disabled={isReadOnly}
                            />
                            <FormattedMessage {...messages.hostAtDestination} />
                        </label>
                        {whoHadDiedCausingTheCancellationTI === 'hostAtDestination' && (
                            <div className="row ml-2" style={{ alignItems: 'center' }}>
                                <div className="col-sm-2 form-group">
                                    <FormattedMessage {...messages.fullName} />
                                </div>
                                <div className="col-sm-6 form-group">
                                    <Textbox
                                        value={fullNameTI}
                                        onChange={this.handleChange('form.fullNameTI')}
                                        disabled={isReadOnly}
                                    />
                                </div>
                            </div>
                        )}

                        <label>
                            <input
                                type="radio"
                                name="whoHadDiedCausingTheCancellationTI"
                                value="someoneElse"
                                checked={whoHadDiedCausingTheCancellationTI === 'someoneElse'}
                                onChange={this.handleChange('form.whoHadDiedCausingTheCancellationTI')}
                                disabled={isReadOnly}
                            />
                            <FormattedMessage {...messages.someoneElse} />
                        </label>
                        {whoHadDiedCausingTheCancellationTI === 'someoneElse' && (
                            <div className="ml-4">
                                <div className="row">
                                    <div className="col-sm-6 form-group">
                                        <Label>
                                            <FormattedMessage {...messages.fullName} />
                                        </Label>
                                        <Textbox
                                            value={fullNameTI}
                                            onChange={this.handleChange('form.fullNameTI')}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-sm-6 form-group">
                                        <Label>
                                            <FormattedMessage {...messages.relationshipToTraveler} />
                                        </Label>
                                        <Textbox
                                            value={relationshipToTravelerTI}
                                            onChange={this.handleChange('form.relationshipToTravelerTI')}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <Label>
                                            <FormattedMessage {...messages.pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled} />
                                        </Label>
                                        <TextArea
                                            value={pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelledTI}
                                            onChange={this.handleChange('form.pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelledTI')}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="row" style={{ alignItems: 'center', marginLeft: '22px' }}>
                        <div className="col-sm-3 form-group">
                            <FormattedMessage {...messages.dateOfDeath} />
                        </div>
                        <div className="col-sm-6 form-group">
                            <DatePicker
                                value={dateOfDeathTI}
                                onChange={this.handleDayChange('form.dateOfDeathTI')}
                                disabled={isReadOnly}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderEmploymentTransfer() {
        const {
            nameOfEmployerTI,
            whenWereYouNotifiedTI,
            dateOfTerminationOrLayoffTI,
            howLongWereYouEmployedTI,
            wasThisWorkTransferTI,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className="ml-3">
                <div className="row mt-2 ml-2">
                    <div className="col-sm-6">
                        <Label>
                            <FormattedMessage {...messages.nameOfEmployer} />
                        </Label>
                        <Textbox
                            value={nameOfEmployerTI}
                            onChange={this.handleChange('form.nameOfEmployerTI')}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div className="col-sm-6">
                        <Label>
                            <FormattedMessage {...messages.whenWereYouNotified} />
                        </Label>
                        <DatePicker
                            value={whenWereYouNotifiedTI}
                            onChange={this.handleDayChange('form.whenWereYouNotifiedTI')}
                            disabled={isReadOnly}
                        />
                    </div>
                </div>
                <div className="row mt-3 ml-2">
                    <div className="col-sm-6">
                        <Label>
                            <FormattedMessage {...messages.dateOfTerminationOrLayoff} />
                        </Label>
                        <DatePicker
                            value={dateOfTerminationOrLayoffTI}
                            onChange={this.handleDayChange('form.dateOfTerminationOrLayoffTI')}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div className="col-sm-6">
                        <Label>
                            <FormattedMessage {...messages.howLongWereYouEmployed} />
                        </Label>
                        <Textbox
                            value={howLongWereYouEmployedTI}
                            onChange={this.handleChange('form.howLongWereYouEmployedTI')}
                            disabled={isReadOnly}
                        />
                    </div>
                </div>
                <div className="row ml-2 mt-3 form-group">
                    <div className="col-sm-6">
                        <FlexBox style={{ justifyContent: 'space-between' }}>
                            <FormattedMessage {...messages.wasThisWorkTransfer} />
                            <FlexBox className="mr-3">
                                <OptionsContainer>
                                    <input
                                        type="radio"
                                        value="true"
                                        checked={wasThisWorkTransferTI === 'true'}
                                        onChange={this.handleChange('form.wasThisWorkTransferTI')}
                                        disabled={isReadOnly}
                                    />
                                    <FormattedMessage {...messages.yes} />
                                </OptionsContainer>
                                <OptionsContainer>
                                    <input
                                        type="radio"
                                        value="false"
                                        checked={wasThisWorkTransferTI === 'false'}
                                        onChange={this.handleChange('form.wasThisWorkTransferTI')}
                                        disabled={isReadOnly}
                                    />
                                    <FormattedMessage {...messages.no} />
                                </OptionsContainer>
                            </FlexBox>
                        </FlexBox>
                    </div>
                </div>
            </div>
        );
    }

    renderCalledToActiveDuty() {
        const {
            nameOfServiceCallingToActiveDutyTI,
            whenWereYouNotifiedTI,
            dateYouBecameTI,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className="ml-3 mb-4">
                <div className="row mt-2 ml-2">
                    <div className="col-sm-6">
                        <Label>
                            <FormattedMessage {...messages.nameOfServiceCallingToActiveDuty} />
                        </Label>
                        <Textbox
                            value={nameOfServiceCallingToActiveDutyTI}
                            onChange={this.handleChange('form.nameOfServiceCallingToActiveDutyTI')}
                            disabled={isReadOnly}
                        />

                    </div>
                </div>

                <div className="row ml-2 mt-4">
                    <div className="col-sm-6">
                        <Label>
                            <FormattedMessage {...messages.whenWereYouNotified} />
                        </Label>
                        <DatePicker
                            value={whenWereYouNotifiedTI}
                            onChange={this.handleDayChange('form.whenWereYouNotifiedTI')}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div className="col-sm-6">
                        <Label>
                            <FormattedMessage {...messages.dateYouBecame} />
                        </Label>
                        <DatePicker
                            value={dateYouBecameTI}
                            onChange={this.handleDayChange('form.dateYouBecameTI')}
                            disabled={isReadOnly}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderRequiredToServeOnAJurySubpoenaedRequireToServeAsAWitness() {
        const {
            nameOfCourtOrAuthorityTI,
            whenWereYouNotifiedTI,
            dateToAppearInCourtTI,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-3 mb-4'}>
                <div className={'row mt-2 ml-2'}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.nameOfCourtOrAuthority} />
                        </Label>
                        <Textbox
                            name="nameOfCourtOrAuthority"
                            type="text"
                            onChange={this.handleChange('form.nameOfCourtOrAuthorityTI')}
                            value={nameOfCourtOrAuthorityTI}
                            disabled={isReadOnly}
                        />

                    </div>
                </div>

                <div className={'row ml-2 mt-4'}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenWereYouNotified} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenWereYouNotified"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenWereYouNotifiedTI')}
                            value={whenWereYouNotifiedTI}
                        />
                    </div>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.dateToAppearInCourt} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateToAppearInCourt"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateToAppearInCourtTI')}
                            value={dateToAppearInCourtTI}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderHijackedVictimOfFeloniousAssault() {
        const {
            nameOfAuthorityHandlingTheIncidentTI,
            dateOfIncidentTI,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-3 mb-4'}>
                <div className={'row ml-2 mt-4'}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.nameOfAuthorityHandlingTheIncident} />
                        </Label>
                        <Textbox
                            name="nameOfAuthorityHandlingTheIncidentTI"
                            type="text"
                            onChange={this.handleChange('form.nameOfAuthorityHandlingTheIncidentTI')}
                            value={nameOfAuthorityHandlingTheIncidentTI}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.dateOfIncident} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateOfIncidentTI"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateOfIncidentTI')}
                            value={dateOfIncidentTI}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderWeatherOrDisaster() {
        const {
            nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosureTI,
            dateOfTransportClosureIncidentTI,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-3 mb-4'}>
                <div className={'row ml-2 mt-4'}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure} />
                        </Label>
                        <Textbox
                            name="nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosureTI"
                            type="text"
                            onChange={this.handleChange('form.nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosureTI')}
                            value={nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosureTI}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.dateOfTransportClosureIncident} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateOfTransportClosureIncidentTI"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateOfTransportClosureIncidentTI')}
                            value={dateOfTransportClosureIncidentTI}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderTrafficAccident() {
        const {
            nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosureTI,
            dateOfTrafficAccidentTI,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-3 mb-4'}>
                <div className={'row ml-2 mt-4'} style={{ alignItems: 'end' }}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure} />
                        </Label>
                        <Textbox
                            name="nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosureTI"
                            type="text"
                            onChange={this.handleChange('form.nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosureTI')}
                            value={nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosureTI}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.dateOfTrafficAccident} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateOfTrafficAccidentTI"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateOfTrafficAccidentTI')}
                            value={dateOfTrafficAccidentTI}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderBankruptcyOfTravelSupplier() {
        const {
            nameOfTravelSupplierTI,
            whenWereYouNotifiedTI,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-3 mb-4'}>
                <div className={'row ml-2 mt-4'} style={{ alignItems: 'end' }}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.nameOfTravelSupplier} />
                        </Label>
                        <Textbox
                            name="nameOfTravelSupplierTI"
                            type="text"
                            onChange={this.handleChange('form.nameOfTravelSupplierTI')}
                            value={nameOfTravelSupplierTI}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenWereYouNotified} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenWereYouNotifiedTI"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenWereYouNotifiedTI')}
                            value={whenWereYouNotifiedTI}
                        />
                    </div>
                </div>
            </div>
        );
    }

    flightVerificationTravelInterruption = (flightObjectName) => () => {
        const travelInterruptionCode = stepChangesToYourJourneyTrawickLookup.travelInterruption.claimCode;
        const { flightNumberTravelInterruption, flightDateTravelInterruption } = this.props.form;
        const isFlightNumberValid = checkFlightNumberOnly(flightNumberTravelInterruption);
        const isFlightDateValid = checkFlightDateOnly(flightDateTravelInterruption);
        if (isFlightNumberValid && isFlightDateValid) {
            if (flightNumberTravelInterruption && flightDateTravelInterruption) {
                this.props.getFlightStatus(flightNumberTravelInterruption, flightDateTravelInterruption, flightObjectName, this.props.stepName, travelInterruptionCode);
            }
        }
    };

    handleChangeFlightDetail = (flightObjectName, propertyName) => (eventOrDay) => {
        const { form } = this.props;
        const flights = form[flightObjectName].flights || [];

        // Determine the value based on whether it's a date picker event or regular input event
        const value = eventOrDay && eventOrDay.target ? eventOrDay.target.value : eventOrDay;

        if (flights.length === 1) {
            // Update first flight's property
            const updatedFlight = { ...flights[0], [propertyName]: value };
            const updatedFlights = [updatedFlight];
            this.props.onFormDataChange(`form.${flightObjectName}.flights`, updatedFlights);
        } else if (flights.length > 1 && form[flightObjectName].selectedFlightIndex !== null) {
            // Update selected flight's property
            const updatedFlights = flights.map((flight, index) => {
                if (index === form[flightObjectName].selectedFlightIndex) {
                    return { ...flight, [propertyName]: value };
                }
                return flight;
            });
            this.props.onFormDataChange(`form.${flightObjectName}.flights`, updatedFlights);
        }
    };

    handleFlightSelection = (propertyName, index) => {
        this.props.onFormDataChange(propertyName, index);
    };

    handleChangeTypeOfTransport = (propertyName) => (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.props.onFormDataChange(propertyName, value);
    };

    renderTravelServiceCessation() {
        const {
            whenDidOperationsResume,
            whenWereYouNotified,
            whatCausedTheServiceCessation,
            flightNumberTravelInterruption,
            flightDateTravelInterruption,
            flightDetailsTravelInterruption,
            typeOfTransportTravelInterruption,
            cruiseLineDetailsTravelInterruption,
            otherDetailsTravelInterruption,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isSummary, submitted } = this.props;
        const isReadOnly = submitted || isSummary;
        const isFlightNumberValid = checkFlightNumberOnly(flightNumberTravelInterruption);
        const isFlightDateValid = checkFlightDateOnly(flightDateTravelInterruption);
        const flights = flightDetailsTravelInterruption.flights || [];
        const flightDetail = flights.length === 1 ? flights[0] : flights[flightDetailsTravelInterruption.selectedFlightIndex];
        const showSectionFlightDetails = flightDetailsTravelInterruption.onSuccessFlighAPIRequest || flightDetailsTravelInterruption.callFailFlighAPIRequest;
        const isDisable = isReadOnly || flightDetailsTravelInterruption.onSuccessFlighAPIRequest || !flightDetailsTravelInterruption.manuallyEnterFlight;
        return (
            <div className={'ml-5 mb-4'}>
                <div>
                    <FormattedMessage {...messages.whatCausedTheServiceCessation} />
                </div>
                <div style={{ display: 'grid', margin: '8px 8px 8px 15px' }}>
                    <label>
                        <input
                            disabled={isReadOnly}
                            type="radio"
                            name="strikeOfACommonCarrier"
                            value="strikeOfACommonCarrier"
                            checked={whatCausedTheServiceCessation === 'strikeOfACommonCarrier'}
                            onChange={this.handleChange('form.whatCausedTheServiceCessation')}
                        />
                        <FormattedMessage {...messages.strikeOfACommonCarrier} />
                    </label>
                    <label>
                        <input
                            disabled={isReadOnly}
                            type="radio"
                            name="mechanicalBreakdownOfCommonCarrier"
                            value="mechanicalBreakdownOfCommonCarrier"
                            checked={whatCausedTheServiceCessation === 'mechanicalBreakdownOfCommonCarrier'}
                            onChange={this.handleChange('form.whatCausedTheServiceCessation')}
                        />
                        <FormattedMessage {...messages.mechanicalBreakdownOfCommonCarrier} />
                    </label>
                    <label>
                        <input
                            disabled={isReadOnly}
                            type="radio"
                            name="inclementWeatherOrNaturalDisaster"
                            value="inclementWeatherOrNaturalDisaster"
                            checked={whatCausedTheServiceCessation === 'inclementWeatherOrNaturalDisaster'}
                            onChange={this.handleChange('form.whatCausedTheServiceCessation')}
                        />
                        <FormattedMessage {...messages.inclementWeatherOrNaturalDisaster} />
                    </label>
                </div>
                <div className={'row ml-2 mt-4'} style={{ alignItems: 'end' }}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenWereYouNotified} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenWereYouNotified"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenWereYouNotified')}
                            value={whenWereYouNotified}
                        />
                    </div>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenDidOperationsResume} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenDidOperationsResume"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenDidOperationsResume')}
                            value={whenDidOperationsResume}
                        />
                    </div>
                </div>
                {whatCausedTheServiceCessation !== '' && (
                    <div>
                        <div className={'pt-2'} style={{ fontWeight: 'bold' }}>
                            <FormattedMessage {...messages.typeOfTransport} />
                        </div>
                        <div className={'ml-2 row pt-2'}>
                            <div className={'col-sm-12 form-group'}>
                                <FlexBox>
                                    <OptionsContainer>
                                        <input
                                            disabled={isReadOnly}
                                            type="radio"
                                            value="airline"
                                            checked={typeOfTransportTravelInterruption === 'airline'}
                                            onChange={this.handleChangeTypeOfTransport('form.typeOfTransportTravelInterruption')}
                                        />
                                        <FormattedMessage {...messages.airline} />
                                    </OptionsContainer>
                                    <OptionsContainer>
                                        <input
                                            disabled={isReadOnly}
                                            type="radio"
                                            value="cruiseLine"
                                            checked={typeOfTransportTravelInterruption === 'cruiseLine'}
                                            onChange={this.handleChangeTypeOfTransport('form.typeOfTransportTravelInterruption')}
                                        />
                                        <FormattedMessage {...messages.cruiseLine} />
                                    </OptionsContainer>
                                    <OptionsContainer>
                                        <input
                                            disabled={isReadOnly}
                                            type="radio"
                                            value="other"
                                            checked={typeOfTransportTravelInterruption === 'other'}
                                            onChange={this.handleChangeTypeOfTransport('form.typeOfTransportTravelInterruption')}
                                        />
                                        <FormattedMessage {...messages.other} />
                                    </OptionsContainer>
                                </FlexBox>
                            </div>
                        </div>
                        {typeOfTransportTravelInterruption === 'airline' &&
                            <div className={'ml-2'}>
                                <PageSectionHeader>
                                    <FormattedMessage {...messages.pleaseEnterYourFlightNumberAndDateBelow} />
                                </PageSectionHeader>
                                <div className={'row'}>
                                    <div className={'col-sm-4 form-group'}>
                                        <Validate
                                            name="flightNumber"
                                            validators={[checkFlightNumberOnly, required]}
                                            group={this.validatorGroup}
                                            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                                            validChangeInGroup={this.validatorGroup.validChangeInGroup}
                                            validationCounter={this.state.validationCounter}
                                            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                                            defaultValue={flightNumberTravelInterruption}
                                            fieldName={messages.flightNumber}
                                        >
                                            <Textbox
                                                name="flightNumber"
                                                type="text"
                                                onChange={this.handleChange('form.flightNumberTravelInterruption')}
                                                value={flightNumberTravelInterruption}
                                                disabled={isReadOnly}
                                            />
                                            <ErrorMessage for="required">
                                                <FormattedMessage
                                                    {...messages.isRequired}
                                                    values={messages.flightNumber}
                                                />
                                            </ErrorMessage>
                                            <ErrorMessage for="checkFlightNumberOnly">
                                                <FormattedMessage
                                                    {...messages.checkFlightNumber}
                                                    values={messages.flightNumber}
                                                />
                                            </ErrorMessage>
                                        </Validate>
                                    </div>
                                    <div className={'col-sm-4 form-group'}>
                                        <Validate
                                            name="flightDate"
                                            validators={[checkFlightDateOnly, required]}
                                            group={this.validatorGroup}
                                            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                                            validChangeInGroup={this.validatorGroup.validChangeInGroup}
                                            validationCounter={this.state.validationCounter}
                                            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                                            defaultValue={flightDateTravelInterruption}
                                            fieldName={messages.flightDate}
                                        >
                                            <FlightDatePicker
                                                position={'bottom-start'}
                                                disabled={isReadOnly}
                                                name="flightDate"
                                                type="text"
                                                onDayChange={this.handleDayChange('form.flightDateTravelInterruption')}
                                                value={flightDateTravelInterruption}
                                            />
                                            <ErrorMessage for="required">
                                                <FormattedMessage
                                                    {...messages.isRequired}
                                                    values={messages.flightDate}
                                                />
                                            </ErrorMessage>
                                            <ErrorMessage for="checkFlightDateOnly">
                                                <FormattedMessage
                                                    {...messages.checkFlightDate}
                                                    values={messages.flightDate}
                                                />
                                            </ErrorMessage>
                                        </Validate>
                                    </div>
                                    <div className={'col-sm-2 form-group'}></div>
                                </div>
                                <div className={'row'}>
                                    <div className={'col-sm-12 form-group'}>
                                        <AsyncButton
                                            id="searchFlightButton"
                                            className={'btn-authentication'}
                                            disabled={isReadOnly || (!isFlightNumberValid && !isFlightDateValid)}
                                            loading={this.props.loading}
                                            spinner={this.showSpinnerForElement('searchFlightButton')}
                                            onClick={this.flightVerificationTravelInterruption('flightDetailsTravelInterruption')}
                                        >
                                            Search Flight
                                        </AsyncButton>
                                    </div>
                                </div>
                                {flightDetailsTravelInterruption.onPendingFlighAPIRequest && (
                                    <div className={'ml-2 row'}>
                                        <div style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage {...messages.pendingFlightApiRequest} />
                                        </div>
                                    </div>
                                )}
                                {flightDetailsTravelInterruption.callFailFlighAPIRequest && flightDetailsTravelInterruption && flightDetailsTravelInterruption.error && (
                                    <div className={'row'}>
                                        <div className={'col-sm-12'} style={{ color: 'red' }}>
                                            {flightDetailsTravelInterruption.error}
                                        </div>
                                    </div>
                                )}
                                {flightDetailsTravelInterruption.callFailFlighAPIRequest && flightDetail && (
                                    <div className={'row'}>
                                        <div className={'form-group col-md-6'}>
                                            <OptionsContainer>
                                                <input
                                                    disabled={isReadOnly}
                                                    type="checkbox"
                                                    name="signature"
                                                    checked={flightDetailsTravelInterruption.manuallyEnterFlight === true}
                                                    onChange={this.handleChange('form.flightDetailsTravelInterruption.manuallyEnterFlight')}
                                                />
                                                <span>
                                                    <FormattedMessage {...messages.manuallyEnterFlight} />
                                                </span>
                                            </OptionsContainer>
                                        </div>
                                        <div className={'form-group col-md-6'}>
                                        </div>
                                    </div>
                                )}
                                {(flightDetailsTravelInterruption.onSuccessFlighAPIRequest && flights.length > 1) && (
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <PageSectionHeader>
                                                <FormattedMessage {...messages.pleaseSelectYourFlightBelow} />
                                            </PageSectionHeader>
                                            <div className="table-responsive">
                                                <table className="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th />
                                                            <th><FormattedMessage {...messages.originAirport} /></th>
                                                            <th><FormattedMessage {...messages.destinationAirport} /></th>
                                                            <th><FormattedMessage {...messages.scheduledDeparture} /></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {flights.map((flight, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <input
                                                                        type="radio"
                                                                        name="selectedFlight"
                                                                        value={index}
                                                                        checked={flightDetailsTravelInterruption.selectedFlightIndex === index}
                                                                        onChange={() => this.handleFlightSelection('form.flightDetailsTravelInterruption.selectedFlightIndex', index)}
                                                                        disabled={isReadOnly}
                                                                    />
                                                                </td>
                                                                <td>{flight.originAirport}</td>
                                                                <td>{flight.destinationAirport}</td>
                                                                <td>{flight.flightDate}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {(showSectionFlightDetails && flightDetail) && (
                                    <div className={'row'}>
                                        <div className={'col-sm-12'}>
                                            <Section>
                                                <ControlContainer className={'ml-3'}>
                                                    <div className={'row'}>
                                                        <div className={'col-sm-2'}>
                                                        </div>
                                                        <div className={'col-sm-3'}>
                                                            <h4>
                                                                <FormattedMessage {...messages.flightDetails} />
                                                            </h4>
                                                        </div>
                                                        <div className={'col-sm-3'}>
                                                            <strong>
                                                                <FormattedMessage {...messages.searchSuccess} />:
                                                            </strong>{' '}
                                                            {flightDetail.success ? 'Yes' : 'No'}
                                                        </div>
                                                        <div className={'col-sm-2'}>
                                                        </div>
                                                    </div>
                                                    <div className={'row'}>
                                                        <div className={'col-sm-6 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.flightNumber} />
                                                            </PageSectionHeader>
                                                            <Textbox
                                                                name="flightNumber"
                                                                type="text"
                                                                onChange={this.handleChangeFlightDetail('flightDetailsTravelInterruption', 'flightNumber')}
                                                                value={flightDetail.flightNumber}
                                                                disabled={isDisable}
                                                            />
                                                        </div>
                                                        <div className={'col-sm-6 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.flightDate} />
                                                            </PageSectionHeader>
                                                            <DatePicker
                                                                name="flightDate"
                                                                type="text"
                                                                onDayChange={this.handleChangeFlightDetail('flightDetailsTravelInterruption', 'flightDate')}
                                                                value={flightDetail.flightDate}
                                                                disabled={isDisable}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className={'row'}>
                                                        <div className={'col-sm-12 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.airline} />
                                                            </PageSectionHeader>
                                                            <Textbox
                                                                name="airline"
                                                                type="text"
                                                                onChange={this.handleChangeFlightDetail('flightDetailsTravelInterruption', 'airline')}
                                                                value={flightDetail.airline}
                                                                disabled={isDisable}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className={'row'}>
                                                        <div className={'col-sm-6 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.originAirport} />
                                                            </PageSectionHeader>
                                                            <Textbox
                                                                name="originAirport"
                                                                type="text"
                                                                onChange={this.handleChangeFlightDetail('flightDetailsTravelInterruption', 'originAirport')}
                                                                value={flightDetail.originAirport}
                                                                disabled={isDisable}
                                                            />
                                                        </div>
                                                        <div className={'col-sm-6 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.destinationAirport} />
                                                            </PageSectionHeader>
                                                            <Textbox
                                                                name="destinationAirport"
                                                                type="text"
                                                                onChange={this.handleChangeFlightDetail('flightDetailsTravelInterruption', 'destinationAirport')}
                                                                value={flightDetail.destinationAirport}
                                                                disabled={isDisable}
                                                            />
                                                        </div>
                                                    </div>
                                                    {!isDisable && (
                                                        <div className={'row'}>
                                                            <div className={'col-sm-6 form-group'}>
                                                                <PageSectionHeader>
                                                                    <FormattedMessage {...messages.scheduledOut} />
                                                                </PageSectionHeader>
                                                                <DatePicker
                                                                    name="scheduledOut"
                                                                    type="text"
                                                                    onDayChange={this.handleChangeFlightDetail('flightDetailsTravelInterruption', 'scheduledOut')}
                                                                    value={flightDetail.scheduledOut}
                                                                    disabled={isDisable}
                                                                />
                                                            </div>
                                                            <div className={'col-sm-6 form-group'}>
                                                                <PageSectionHeader>
                                                                    <FormattedMessage {...messages.scheduledIn} />
                                                                </PageSectionHeader>
                                                                <DatePicker
                                                                    name="scheduledIn"
                                                                    type="text"
                                                                    onDayChange={this.handleChangeFlightDetail('flightDetailsTravelInterruption', 'scheduledIn')}
                                                                    value={flightDetail.scheduledIn}
                                                                    disabled={isDisable}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                    {isDisable && (
                                                        <div className={'row'}>
                                                            <div className={'col-sm-6 form-group'}>
                                                                <PageSectionHeader>
                                                                    <FormattedMessage {...messages.scheduledOut} />
                                                                </PageSectionHeader>
                                                                <Textbox
                                                                    name="scheduledOut"
                                                                    type="text"
                                                                    onDayChange={this.handleChangeFlightDetail('flightDetailsTravelInterruption', 'scheduledOut')}
                                                                    value={flightDetail.scheduledOut}
                                                                    disabled={isDisable}
                                                                />
                                                            </div>
                                                            <div className={'col-sm-6 form-group'}>
                                                                <PageSectionHeader>
                                                                    <FormattedMessage {...messages.scheduledIn} />
                                                                </PageSectionHeader>
                                                                <Textbox
                                                                    name="scheduledIn"
                                                                    type="text"
                                                                    onDayChange={this.handleChangeFlightDetail('flightDetailsTravelInterruption', 'scheduledIn')}
                                                                    value={flightDetail.scheduledIn}
                                                                    disabled={isDisable}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className={'row'}>
                                                        <div className={'col-sm-3 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.departureDelay} />
                                                            </PageSectionHeader>
                                                            <Textbox
                                                                name="departureDelay"
                                                                type="number"
                                                                onChange={this.handleChangeFlightDetail('flightDetailsTravelInterruption', 'departureDelay')}
                                                                value={flightDetail.departureDelay}
                                                                disabled={isDisable}
                                                            />
                                                        </div>
                                                        <div className={'col-sm-3 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.arrivalDelay} />
                                                            </PageSectionHeader>
                                                            <Textbox
                                                                name="arrivalDelay"
                                                                type="number"
                                                                onChange={this.handleChangeFlightDetail('flightDetailsTravelInterruption', 'arrivalDelay')}
                                                                value={flightDetail.arrivalDelay}
                                                                disabled={isDisable}
                                                            />
                                                        </div>
                                                        <div className={'col-sm-6 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.cancelled} />
                                                            </PageSectionHeader>
                                                            <select
                                                                name="cancelled"
                                                                className="form-control"
                                                                onChange={this.handleChangeFlightDetail('flightDetailsTravelInterruption', 'cancelled')}
                                                                value={flightDetail.cancelled || ''}
                                                                disabled={isDisable}
                                                            >
                                                                <option value="">Select status</option>
                                                                <option value="Yes">Yes</option>
                                                                <option value="No">No</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </ControlContainer>
                                            </Section>
                                        </div>
                                    </div>
                                )}
                            </div>
                        }
                        {typeOfTransportTravelInterruption === 'cruiseLine' &&
                            <div className={'ml-2'}>
                                <div className={'row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.cruiseLine} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="cruiseLine"
                                            type="text"
                                            onChange={this.handleChange('form.cruiseLineDetailsTravelInterruption.cruiseLine')}
                                            value={cruiseLineDetailsTravelInterruption.cruiseLine}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.cruiseNumber} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="cruiseNumber"
                                            type="text"
                                            onChange={this.handleChange('form.cruiseLineDetailsTravelInterruption.cruiseNumber')}
                                            value={cruiseLineDetailsTravelInterruption.cruiseNumber}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                                <div className={'row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.departureDate} />
                                        </PageSectionHeader>
                                        <DatePicker
                                            name="departureDate"
                                            type="text"
                                            onDayChange={this.handleDayChange('form.cruiseLineDetailsTravelInterruption.departureDate')}
                                            value={cruiseLineDetailsTravelInterruption.departureDate}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.arrivalDate} />
                                        </PageSectionHeader>
                                        <DatePicker
                                            name="arrivalDate"
                                            type="text"
                                            onDayChange={this.handleDayChange('form.cruiseLineDetailsTravelInterruption.arrivalDate')}
                                            value={cruiseLineDetailsTravelInterruption.arrivalDate}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                                <div className={'row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.departurePort} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="departurePort"
                                            type="text"
                                            onChange={this.handleChange('form.cruiseLineDetailsTravelInterruption.departurePort')}
                                            value={cruiseLineDetailsTravelInterruption.departurePort}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.arrivalPort} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="arrivalPort"
                                            type="text"
                                            onChange={this.handleChange('form.cruiseLineDetailsTravelInterruption.arrivalPort')}
                                            value={cruiseLineDetailsTravelInterruption.arrivalPort}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {typeOfTransportTravelInterruption === 'other' &&
                            <div className={'ml-2'}>
                                <div className={'row'}>
                                    <div className={'col-sm-12 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled} />
                                        </PageSectionHeader>
                                        <TextArea
                                            name="pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled"
                                            type="text"
                                            onChange={this.handleChange('form.otherDetailsTravelInterruption.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled')}
                                            value={otherDetailsTravelInterruption.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                                <div className={'row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.departureDate} />
                                        </PageSectionHeader>
                                        <DatePicker
                                            name="departureDate"
                                            type="text"
                                            onDayChange={this.handleDayChange('form.otherDetailsTravelInterruption.departureDate')}
                                            value={otherDetailsTravelInterruption.departureDate}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                                <div className={'row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.departureLocation} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="departureLocation"
                                            type="text"
                                            onChange={this.handleChange('form.otherDetailsTravelInterruption.departureLocation')}
                                            value={otherDetailsTravelInterruption.departureLocation}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.destination} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="destination"
                                            type="text"
                                            onChange={this.handleChange('form.otherDetailsTravelInterruption.destination')}
                                            value={otherDetailsTravelInterruption.destination}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                                <div className={'row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.descriptionOfTravelType} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="descriptionOfTravelType"
                                            type="text"
                                            onChange={this.handleChange('form.otherDetailsTravelInterruption.descriptionOfTravelType')}
                                            value={otherDetailsTravelInterruption.descriptionOfTravelType}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.descriptionOfEvent} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="descriptionOfEvent"
                                            type="text"
                                            onChange={this.handleChange('form.otherDetailsTravelInterruption.descriptionOfEvent')}
                                            value={otherDetailsTravelInterruption.descriptionOfEvent}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                )}
            </div>
        );
    }

    renderNaturalDisasterResidence() {
        const {
            whenWereYouNotifiedTI,
            whereWasUninhabitableTI,
            whenWasThePrimaryResidenceOrDestinationDeemedUninhabitableTI,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-5 mb-4'}>
                <div>
                    <FormattedMessage {...messages.whereWasUninhabitable} />
                </div>
                <div style={{ display: 'grid', margin: '8px 8px 8px 15px' }}>
                    <label>
                        <input
                            disabled={isReadOnly}
                            type="radio"
                            name="primaryResidence"
                            value="primaryResidence"
                            checked={whereWasUninhabitableTI === 'primaryResidence'}
                            onChange={this.handleChange('form.whereWasUninhabitableTI')}
                        />
                        <FormattedMessage {...messages.primaryResidence} />
                    </label>
                    <label>
                        <input
                            disabled={isReadOnly}
                            type="radio"
                            name="destination"
                            value="destination"
                            checked={whereWasUninhabitableTI === 'destination'}
                            onChange={this.handleChange('form.whereWasUninhabitableTI')}
                        />
                        <FormattedMessage {...messages.destination} />
                    </label>
                </div>

                <div className={'row ml-2'} style={{ alignItems: 'end' }}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenWereYouNotified} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenWereYouNotifiedTI"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenWereYouNotifiedTI')}
                            value={whenWereYouNotifiedTI}
                        />
                    </div>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenWasThePrimaryResidenceOrDestinationDeemedUninhabitable} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenWasThePrimaryResidenceOrDestinationDeemedUninhabitableTI"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenWasThePrimaryResidenceOrDestinationDeemedUninhabitableTI')}
                            value={whenWasThePrimaryResidenceOrDestinationDeemedUninhabitableTI}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderTerroristIncident() {
        const {
            whenWereYouNotifiedTI,
            provideDetailsOfTheIncidentTI,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-5 mb-4'}>
                <div className={''}>
                    <Label>
                        <FormattedMessage {...messages.provideDetailsOfTheIncident} />
                    </Label>
                    <TextArea
                        name="provideDetailsOfTheIncidentTI"
                        type="text"
                        onChange={this.handleChange('form.provideDetailsOfTheIncidentTI')}
                        value={provideDetailsOfTheIncidentTI}
                        disabled={isReadOnly}
                    />
                </div>

                <div className={'row mt-2'} style={{ alignItems: 'end' }}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenWereYouNotified} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenWereYouNotifiedTI"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenWereYouNotifiedTI')}
                            value={whenWereYouNotifiedTI}
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            travelInterruption,
            reasonsForTripInterruption,
            dateTripInterrupted,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isSummary, submitted, jsonVersion, isClaimGroupAllowed } = this.props;
        const reasonsForTripInterruptions = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
            ? reasonsForTripInterruption.toJS()
            : reasonsForTripInterruption || [];

        const isReadOnly = submitted || isSummary;
        const isOnlyOne = reasonsForTripInterruptions.length > 0;

        const isSicknessOrInjuryChecked = reasonsForTripInterruptions.includes('sicknessOrInjury');
        const isDeathChecked = reasonsForTripInterruptions.includes('death');
        const isEmploymentTransferChecked = reasonsForTripInterruptions.includes('employmentTransfer');
        const isCalledToActiveDutyChecked = reasonsForTripInterruptions.includes('calledToActiveDuty');
        const isRequiredToServeOnAJurySubpoenaedRequireToServeAsAWitnessChecked = reasonsForTripInterruptions.includes('requiredToServeOnAJurySubpoenaedRequireToServeAsAWitness');
        const isHijackedVictimOfFeloniousAssaultChecked = reasonsForTripInterruptions.includes('hijackedVictimOfFeloniousAssault');
        const isWeatherOrDisasterChecked = reasonsForTripInterruptions.includes('weatherOrDisaster');
        const isTrafficAccident = reasonsForTripInterruptions.includes('trafficAccident');
        const isbankruptcyOfTravelSupplierChecked = reasonsForTripInterruptions.includes('bankruptcyOfTravelSupplier');
        const isTravelServiceCessationChecked = reasonsForTripInterruptions.includes('travelServiceCessation');
        const isNaturalDisasterResidenceChecked = reasonsForTripInterruptions.includes('naturalDisasterResidence');
        const isTerroristIncident = reasonsForTripInterruptions.includes('terroristIncident');
        return (
            <div>
                {travelInterruption === 'true' && (
                    <div className={'ml-3'}>
                        <div className={'col-sm-12 form-group'}>
                            <Validate
                                name="reasonsForTripInterruption"
                                validators={[required]}
                                group={this.props.validatorGroup}
                                addValidatorToGroup={this.props.validatorGroup.addValidatorToGroup}
                                validChangeInGroup={this.props.validatorGroup.validChangeInGroup}
                                validationCounter={this.props.validationCounter}
                                validatorLeaveGroup={this.props.validatorGroup.removeValidatorToGroup}
                                defaultValue={reasonsForTripInterruptions}
                                fieldName={messages.reasonsForTripInterruption}
                                tooltipContent={messages.travelInterruptionTooltip.defaultMessage}
                                tooltipDataFor={'reasonsForTripInterruptionHint'}
                                tooltipPlace={'bottom'}
                            >
                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isSicknessOrInjuryChecked}
                                        type="checkbox"
                                        name="sicknessOrInjury"
                                        checked={isSicknessOrInjuryChecked}
                                        onChange={this.handlereasonsForTripInterruption('form.reasonsForTripInterruption')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.sicknessOrInjury} />
                                    </span>
                                </div>

                                <div>
                                    {isSicknessOrInjuryChecked && this.renderSickOrInjured()}
                                </div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isDeathChecked}
                                        type="checkbox"
                                        name="death"
                                        checked={isDeathChecked}
                                        onChange={this.handlereasonsForTripInterruption('form.reasonsForTripInterruption')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.death} />
                                    </span>
                                </div>
                                <div>
                                    {isDeathChecked && this.renderDeath()}
                                </div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isEmploymentTransferChecked}
                                        type="checkbox"
                                        name="employmentTransfer"
                                        checked={isEmploymentTransferChecked}
                                        onChange={this.handlereasonsForTripInterruption('form.reasonsForTripInterruption')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.employmentTransfer} />
                                    </span>
                                </div>

                                <div>{isEmploymentTransferChecked && (this.renderEmploymentTransfer())}</div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isCalledToActiveDutyChecked}
                                        type="checkbox"
                                        name="calledToActiveDuty"
                                        checked={isCalledToActiveDutyChecked}
                                        onChange={this.handlereasonsForTripInterruption('form.reasonsForTripInterruption')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.calledToActiveDuty} />
                                    </span>
                                </div>
                                <div>{isCalledToActiveDutyChecked && this.renderCalledToActiveDuty()} </div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isRequiredToServeOnAJurySubpoenaedRequireToServeAsAWitnessChecked}
                                        type="checkbox"
                                        name="requiredToServeOnAJurySubpoenaedRequireToServeAsAWitness"
                                        checked={isRequiredToServeOnAJurySubpoenaedRequireToServeAsAWitnessChecked}
                                        onChange={this.handlereasonsForTripInterruption('form.reasonsForTripInterruption')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.requiredToServeOnAJurySubpoenaedRequireToServeAsAWitness} />
                                    </span>
                                </div>
                                <div>
                                    {isRequiredToServeOnAJurySubpoenaedRequireToServeAsAWitnessChecked && (this.renderRequiredToServeOnAJurySubpoenaedRequireToServeAsAWitness())}
                                </div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isHijackedVictimOfFeloniousAssaultChecked}
                                        type="checkbox"
                                        name="hijackedVictimOfFeloniousAssault"
                                        checked={isHijackedVictimOfFeloniousAssaultChecked}
                                        onChange={this.handlereasonsForTripInterruption('form.reasonsForTripInterruption')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.hijackedVictimOfFeloniousAssault} />
                                    </span>
                                </div>
                                <div>
                                    {isHijackedVictimOfFeloniousAssaultChecked && (this.renderHijackedVictimOfFeloniousAssault())}
                                </div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isWeatherOrDisasterChecked}
                                        type="checkbox"
                                        name="weatherOrDisaster"
                                        checked={isWeatherOrDisasterChecked}
                                        onChange={this.handlereasonsForTripInterruption('form.reasonsForTripInterruption')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.weatherOrDisaster} />
                                    </span>
                                </div>
                                <div>
                                    {isWeatherOrDisasterChecked && this.renderWeatherOrDisaster()}
                                </div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isTrafficAccident}
                                        type="checkbox"
                                        name="trafficAccident"
                                        checked={isTrafficAccident}
                                        onChange={this.handlereasonsForTripInterruption('form.reasonsForTripInterruption')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.trafficAccident} />
                                    </span>
                                </div>
                                <div>
                                    {isTrafficAccident && (this.renderTrafficAccident())}
                                </div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isbankruptcyOfTravelSupplierChecked}
                                        type="checkbox"
                                        name="bankruptcyOfTravelSupplier"
                                        checked={isbankruptcyOfTravelSupplierChecked}
                                        onChange={this.handlereasonsForTripInterruption('form.reasonsForTripInterruption')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.bankruptcyOfTravelSupplier} />
                                    </span>
                                </div>
                                <div>{isbankruptcyOfTravelSupplierChecked && this.renderBankruptcyOfTravelSupplier()}</div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('travelServiceCessation')}
                                        type="checkbox"
                                        name="travelServiceCessation"
                                        checked={reasonsForTripInterruptions.includes('travelServiceCessation')}
                                        onChange={this.handlereasonsForTripInterruption('form.reasonsForTripInterruption')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.travelServiceCessation} />
                                    </span>
                                </div>
                                <div>{isTravelServiceCessationChecked && this.renderTravelServiceCessation()}</div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('naturalDisasterResidence')}
                                        type="checkbox"
                                        name="naturalDisasterResidence"
                                        checked={reasonsForTripInterruptions.includes('naturalDisasterResidence')}
                                        onChange={this.handlereasonsForTripInterruption('form.reasonsForTripInterruption')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.naturalDisasterResidence} />
                                    </span>
                                </div>
                                <div>{isNaturalDisasterResidenceChecked && this.renderNaturalDisasterResidence()}</div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('terroristIncident')}
                                        type="checkbox"
                                        name="terroristIncident"
                                        checked={reasonsForTripInterruptions.includes('terroristIncident')}
                                        onChange={this.handlereasonsForTripInterruption('form.reasonsForTripInterruption')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.terroristIncident} />
                                    </span>
                                </div>
                                <div>{isTerroristIncident && this.renderTerroristIncident()}</div>

                                <div className={'ml-1 row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <Validate
                                            name="dateTripInterrupted"
                                            validators={[checkDateOnly, required]}
                                            group={this.props.validatorGroup}
                                            addValidatorToGroup={this.props.validatorGroup.addValidatorToGroup}
                                            validChangeInGroup={this.props.validatorGroup.validChangeInGroup}
                                            validationCounter={this.props.validationCounter}
                                            validatorLeaveGroup={this.props.validatorGroup.removeValidatorToGroup}
                                            defaultValue={dateTripInterrupted}
                                            fieldName={messages.dateTripInterrupted}
                                        >
                                            <DatePicker
                                                position={'bottom-start'}
                                                disabled={isReadOnly}
                                                name="dateTripInterrupted"
                                                type="text"
                                                onDayChange={this.handleDayChange('form.dateTripInterrupted')}
                                                value={dateTripInterrupted}
                                            />
                                            <ErrorMessage for="required">
                                                <FormattedMessage
                                                    {...messages.isRequired}
                                                    values={messages.dateTripInterrupted}
                                                />
                                            </ErrorMessage>
                                            <ErrorMessage for="checkDateOnly">
                                                <FormattedMessage
                                                    {...messages.checkEventDate}
                                                    values={messages.dateTripInterrupted}
                                                />
                                            </ErrorMessage>
                                        </Validate>
                                    </div>
                                    <div className={'col-sm-6 form-group'}>
                                    </div>
                                </div>

                                <div className={'ml-3 row'}>
                                    <div className={'col-sm-12'}>
                                        <HelpText>
                                            {messages.equalAmountClaimNote.defaultMessage}
                                        </HelpText>
                                    </div>
                                </div>
                                <div className={'ml-3 mt-3'}>
                                    <PageSectionHeader>
                                        <FormattedMessage
                                            {...(isClaimGroupAllowed ? messages.lossInformationPerPerson : messages.lossInformation)}
                                        />
                                    </PageSectionHeader>
                                    {this.renderTripInterruptionInformationItems()}
                                </div>
                                <ErrorMessage for="required">
                                    <FormattedMessage
                                        {...messages.isRequired}
                                        values={messages.reasonsForTripInterruption}
                                    />
                                </ErrorMessage>
                            </Validate>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

TripInterruptionVersion14AndAbove.propTypes = {
    form: PropTypes.object,
    isSummary: PropTypes.bool,
    submitted: PropTypes.bool,
    isClaimForFieldEnabled: PropTypes.bool,
    isClaimGroupAllowed: PropTypes.bool,
    jsonVersion: PropTypes.number,
    appendIds: PropTypes.func,
    resetFormFields: PropTypes.func,
    onFormDataChange: PropTypes.func,
    onTravelCancellationItemsChange: PropTypes.func,
    onTripInterruptionChange: PropTypes.func,
    insuredsList: PropTypes.array,
    validatorGroup: PropTypes.object,
    validationCounter: PropTypes.number,
    loading: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    getFlightStatus: PropTypes.func,
    stepName: PropTypes.string,
    resetFormFields: PropTypes.func,
};





// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.ChangesToYourJourney/components/TripInterruptionVersion14AndAbove/index.js